'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Loading = require('../../../../common/components/Loading.js');
var ErrorBanner = require('../../../../common/components/ErrorBanner.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookSettings = require('@narvar/nth-hook-settings');
var OrderNumberField = require('../../../../common/views/OrderLookup/fields/OrderNumberField.js');
var EmailField = require('../../../../common/views/OrderLookup/fields/EmailField.js');
var ClaimReasonField = require('../../../../common/views/OrderLookup/fields/ClaimReasonField.js');
var useOrderLookupForm = require('../../../../common/views/OrderLookup/useOrderLookupForm.js');
var Spacer = require('../../../../common/views/OrderLookup/Spacer.js');
var useEligibilityQuery = require('./useEligibilityQuery.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');
var SessionContext = require('../../../../common/providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OrderLookupForm = () => {
  const [firstRender, setFirstRender] = React.useState(true);
  const {
    customerPrivacyUrl,
    claimTypeOptionActions
  } = nthHookSettings.useSettings();
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    claimsButtonNext,
    claimsOrderLookupTitle,
    claimsOrderLookupDescription,
    claimsOrderLookupLoading,
    claimsOrderLookupReasonDescription,
    claimsOrderLookupReadOurPolicy,
    claimsOrderLookupApiErrorOrderNotFound,
    claimsOrderLookupApiErrorUnknown
  } = nthHookTranslations.useTranslations();
  const titan = useTitanAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    onSubmit,
    onChange,
    values,
    errors,
    submitEnabled,
    apiErrorMessage,
    loading
  } = useOrderLookupForm["default"]({
    useEligibilityQuery: useEligibilityQuery["default"],
    claimTypeOptionActions: claimTypeOptionActions ?? {},
    apiErrorMessages: {
      claimsOrderLookupApiErrorOrderNotFound: claimsOrderLookupApiErrorOrderNotFound ?? '',
      claimsOrderLookupApiErrorUnknown: claimsOrderLookupApiErrorUnknown ?? ''
    }
  });

  // We only attempt to autosubmit if we have all values and it's the first render
  const shouldAutoSubmit = firstRender && !!(values.claimTypeOption && values.email && values.orderNumber);
  React.useEffect(() => {
    if (shouldAutoSubmit) {
      onSubmit();
    }
  }, [shouldAutoSubmit, onSubmit, setFirstRender]);
  React.useEffect(() => {
    if (firstRender) {
      setFirstRender(false);
    }
  }, [firstRender, setFirstRender]);
  return /*#__PURE__*/React__default["default"].createElement(Loading["default"], {
    loading: loading || shouldAutoSubmit,
    text: claimsOrderLookupLoading || ''
  }, apiErrorMessage && /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, apiErrorMessage)), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, claimsOrderLookupTitle), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, claimsOrderLookupDescription), /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(OrderNumberField["default"], {
    error: errors.orderNumber,
    value: values.orderNumber,
    onChange: onChange
  })), /*#__PURE__*/React__default["default"].createElement(EmailField["default"], {
    error: errors.email,
    value: values.email,
    onChange: onChange
  }), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, claimsOrderLookupReasonDescription), /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(ClaimReasonField["default"], {
    value: values.claimTypeOption,
    error: errors.claimTypeOption,
    onChange: onChange,
    logTitan: titan === null || titan === void 0 ? void 0 : titan.track,
    orderNumber: orderNumber
  })), /*#__PURE__*/React__default["default"].createElement(Spacer["default"], null, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    type: Button.ButtonType.submit,
    big: true,
    disabled: !submitEnabled
  }, claimsButtonNext)), customerPrivacyUrl && /*#__PURE__*/React__default["default"].createElement(Spacer["default"], {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    target: TextLink.TextLinkTargetType.BLANK,
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    },
    href: customerPrivacyUrl
  }, claimsOrderLookupReadOurPolicy))));
};
var OrderLookupForm$1 = nthHookSettings.withSettingsProvider(nthHookTheme.withThemeProvider(nthHookTranslations.withTranslationsProvider(OrderLookupForm, {
  translationKeys: ['claimsButtonNext', 'claimsOrderLookupTitle', 'claimsOrderLookupDescription', 'claimsOrderLookupLoading', 'claimsOrderLookupReasonDescription', 'claimsOrderLookupReadOurPolicy', 'claimsOrderLookupApiErrorOrderNotFound', 'claimsOrderLookupApiErrorUnknown']
}), {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  settingsRequested: `
      claimTypeOptionActions {
        ItemMissing {
          actionType
          redirectUrl
        }
        ItemDamaged {
          actionType
          redirectUrl
        }
        PackageMissing {
          actionType
          redirectUrl
        }
        WrongItem {
          actionType
          redirectUrl
        }
      }
      customerPrivacyUrl
    `
});

exports["default"] = OrderLookupForm$1;
